export const BRAND = {
  name: "Velixa Health",
  tagline: "Care at Home. Comfort in every moment.",
  phone: "7483985244",
  phoneDisplay: "+91 748 398 5244",
  phoneTel: "+917483985244",
  email: "velixahealth1@gmail.com",
  whatsapp: "https://wa.me/917483985244",
  waNumber: "917483985244",
  city: "Whitefield, Bangalore",
  rating: "4.9",
  ratingCount: 41,
  logo: "https://customer-assets-eiarnc6j.emergentagent.net/job_home-healthcare-wf/artifacts/n7fn6qhf_logo%20velixa.png",
  founderPhoto: "https://customer-assets-eiarnc6j.emergentagent.net/job_home-healthcare-wf/artifacts/68cef7a4d9702fac_Velixa%20Health%20Team%20Portraits.png",
};

// Legacy helper (kept for compatibility with existing imports). Prefer buildWaLink from lib/services.js.
export const waLink = (text = "Hi Velixa Health, I need help with home care for my family member. Can you guide me?") =>
  `${BRAND.whatsapp}?text=${encodeURIComponent(text)}`;

export const NEARBY_AREAS = [
  "Whitefield", "Brookfield", "ITPL", "Kadugodi", "Varthur", "Hoodi",
  "Marathahalli", "KR Puram", "Mahadevapura", "Bellandur", "Sarjapur Road",
  "HSR Layout", "Koramangala", "Indiranagar", "Electronic City",
];

export const NAV_LINKS = [
  { to: "/services", label: "Services", hasMega: true },
  { to: "/for-families-abroad", label: "For Families Abroad" },
  { to: "/#checkups", label: "Health Checkups" },
  { to: "/about", label: "About" },
  { to: "/contact", label: "Contact" },
];

// FAQs for home page (keeps old + 2 new).
export const FAQS = [
  { q: "Do you provide IV injections at home in Bangalore?", a: "Yes. Our trained nurses administer doctor-prescribed IV injections at home across Bangalore. A valid prescription is required." },
  { q: "How much do your services cost?", a: "Pricing is personalised after a quick assessment — it depends on the patient's condition, service duration and location. Call or WhatsApp us and we'll share a fair quote." },
  { q: "Do you provide caretakers for elderly parents living alone?", a: "Yes. We offer trained caretakers and patient attendants on 12-hour and 24-hour schedules. We send regular WhatsApp updates to family members, including those abroad." },
  { q: "Can I book from abroad?", a: "Absolutely. Many of our clients are NRI families whose parents live in Bangalore. WhatsApp us on +91 7483985244 — we handle everything, including sharing visit summaries after each shift." },
  { q: "Do you offer 24-hour home nurse?", a: "Yes. Round-the-clock care is available — usually two nurses rotating in 12-hour shifts so the family never has to stay up at night." },
  { q: "Which areas do you serve?", a: "We're based in Whitefield and serve all of Bangalore. Response time is fastest in East Bangalore (Whitefield, Marathahalli, KR Puram, Hoodi) but we cover the whole city." },
  { q: "Is this an emergency service?", a: "No. Velixa Health provides scheduled home healthcare. In an emergency, call 108 or 112 or go to the nearest hospital." },
];

export const TRUST_POINTS = [
  { icon: "UserCheck", title: "Nurse-led team", desc: "Founded and led by nurses from Manipal Hospitals." },
  { icon: "Clock", title: "Available 24 / 7", desc: "Day, night, Sundays — we pick up the phone." },
  { icon: "ShieldCheck", title: "Hygiene & infection control", desc: "Sterile technique and single-use consumables." },
  { icon: "ClipboardCheck", title: "Personalised care plans", desc: "A plan built around your family — not a template." },
];

export const WHY_CHOOSE = [
  { icon: "GraduationCap", title: "Nurse-led team with hospital experience", desc: "Founders are former Manipal Hospitals nurses — your care is clinically sound." },
  { icon: "Clock", title: "Available 24 / 7", desc: "Mornings, nights and Sundays — someone will answer." },
  { icon: "Zap", title: "Fast response — we're local", desc: "Based in Whitefield, serving all of Bangalore." },
  { icon: "ShieldCheck", title: "Hygiene without compromise", desc: "Sterile technique and infection-prevention protocols always." },
  { icon: "HeartHandshake", title: "Care plans, not price tags", desc: "Every quote begins with an assessment, never a slab." },
  { icon: "CreditCard", title: "Easy payment", desc: "UPI, cash, card and bank transfer." },
];

export const HOW_STEPS = [
  { n: "1", title: "Call or WhatsApp", desc: "Reach us anytime on 7483985244 — day or night." },
  { n: "2", title: "Share patient details", desc: "Condition, location and the kind of care needed." },
  { n: "3", title: "Get a personalised care plan", desc: "A fair quote and the right trained professional for you." },
  { n: "4", title: "Care arrives at home", desc: "Punctual, prepared and in uniform — ready to help." },
];

// Placeholder reviews — real Google reviews will be added later.
export const REVIEW_PLACEHOLDERS = [
  { stars: 5, name: "", area: "", quote: "Add real Google review here (placeholder — the user will paste real reviews later)." },
  { stars: 5, name: "", area: "", quote: "Add real Google review here (placeholder — the user will paste real reviews later)." },
  { stars: 5, name: "", area: "", quote: "Add real Google review here (placeholder — the user will paste real reviews later)." },
  { stars: 5, name: "", area: "", quote: "Add real Google review here (placeholder — the user will paste real reviews later)." },
];
